import { useCallback, useState } from 'react';
export const useDisclose = ({
  open: openProp,
  defaultOpen
} = {}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen ?? false);
  const open = openProp ?? isOpen;
  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const onToggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);
  return {
    open,
    onOpen,
    onClose,
    onToggle
  };
};
//# sourceMappingURL=useDisclose.js.map